const apiVersion = "v1";
export const API_TOKEN_ENDPOINT = `/api/${apiVersion}/Account/token`;
export const API_PROXY_CLIENT_LOGIN_ENDPOINT = `/api/${apiVersion}/Account/proxyClientLogin`;
export const API_PROXY_REFRESHTOKEN_ENDPOINT = `/api/${apiVersion}/Account/proxyRefreshToken`;
export const API_PROXY_LOGOUT_ENDPOINT = `/api/${apiVersion}/Account/proxyLogout`;
export const API_VALIDATETOKEN_ENDPOINT = `/api/${apiVersion}/Account/validateToken`;
export const API_FORGOT_PASSWORD_ENDPOINT = `/api/${apiVersion}/Account/forgot-password`;
export const API_RESET_PASSWORD_ENDPOINT = `/api/${apiVersion}/Account/reset-password`;
export const API_VALIDATE_RESET_TOKEN_ENDPOINT = `/api/${apiVersion}/Account/validate-reset-token`;

export const API_USER_ENDPOINT = `/api/${apiVersion}/User`;

export const API_PRODUCT_ENDPOINT = `/api/${apiVersion}/Product`;
export const API_FEATURE_ENDPOINT = `/api/${apiVersion}/Feature`;

export const API_ROLE_ENDPOINT = `/api/${apiVersion}/Role`;
export const API_PERMISSION_ENDPOINT = `/api/${apiVersion}/Permission`;
export const API_USERROLE_ENDPOINT = `/api/${apiVersion}/UserRole`;

export const API_USERPRODUCT_ENDPOINT = `/api/${apiVersion}/UserProduct`;

export const API_SALES_TAX_ENGINE_ENDPOINT = `/api/Query`;

export const API_SALES_TAX_ENGINE_BASE_URL = `/api/SalesTax`;
export const API_DEALER_ENDPOINT = `/api/${apiVersion}/Dealership`;
export const API_SUBSCRIPTION_ENDPOINT = `/api/${apiVersion}/Subscriptions`;
export const API_ADDONS_ENDPOINT = `/api/${apiVersion}/AddOns`;

// OTP endpoints
export const API_SEND_OTP_ENDPOINT = `/api/${apiVersion}/Otp/send`;
export const API_VERIFY_OTP_ENDPOINT = `/api/${apiVersion}/Otp/verify`;
